export default __webpack_public_path__ + "static/media/Untitled_Artwork 18.473fc35f.png";